import { DataBean } from "../../DataBean";


export class HealthIDTypeCatalog extends DataBean {

    public async getHealthIDTypeCatalog(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthIDTypeCatalog_Number", [args]);
    }

}